import React, { useState,useEffect } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { Link } from 'react-router-dom'
import {  userActions,authActions } from "../../../_store";

import MsgBox from './MsgBox'

const Chat = ({ PerfectScrollbar, toggleChatBox, toggleTab }) => {
  const dispatch = useDispatch();
  const messageUserList = useSelector((x) => x.users.messageUserList);
  const currentUser = useSelector((x) => x.auth.user);

  const [openMsg, setOpenMsg] = useState(false);
  const [chatDetail, setChatDetail] = useState({SenderID:0,ReceiverID:0,FirstName:"",LastName:"",SenderUserType:""});
  
  useEffect(() => {
    if(openMsg)
    {
      setOpenMsg(false);
    }
 }, [messageUserList]);

  // Utility function to adjust color brightness
const adjustColorBrightness = (color, amount) => {
  let usePound = false;
  if (color[0] === "#") {
    color = color.slice(1);
    usePound = true;
  }

  let num = parseInt(color, 16);
  let r = (num >> 16) + amount;
  let g = ((num >> 8) & 0x00FF) + amount;
  let b = (num & 0x0000FF) + amount;

  r = Math.max(Math.min(255, r), 0);
  g = Math.max(Math.min(255, g), 0);
  b = Math.max(Math.min(255, b), 0);

  return (usePound ? "#" : "") + ((r << 16) | (g << 8) | b).toString(16).padStart(6, '0');
};

const handleMsgBox= (UserID,FirstName,LastName,UserType,IsOpen) => {
  let chat={...chatDetail};
  
  chat.ReceiverID=currentUser.Id;
  chat.SenderID=UserID;
  chat.FirstName=FirstName;
  chat.LastName=LastName;
  chat.SenderUserType=UserType;
  let userTypeName = currentUser.UserTypeID === 1 ? "SuperAdmin" : currentUser.UserTypeID === 2 ? "Admin" : currentUser.UserTypeID === 3 ? "OrderAnalyst" : currentUser.UserTypeID === 4 ? "Dispatcher" : currentUser.UserTypeID === 5 ? "WarehouseManager" : currentUser.UserTypeID === 6 ? "WarehouseAssistant" : currentUser.UserTypeID === 7 ? "Accountant" : "";
  chat.ReceiverUserType=userTypeName;
  if(chat.SenderID >0 && chat.ReceiverID>0)
   {
     dispatch(userActions.getAndUpdateMessageList({SenderID: chat.SenderID,ReceiverID:chat.ReceiverID})).then((response) => {
     if (response?.type === 'users/getAndUpdateMessageList/fulfilled') {
      let userDetail={...currentUser};
      userDetail.NotificationCount=response?.payload?.NotificationCount;
        dispatch(authActions.updateLocalStorage(userDetail));
     }
    });
 
  }

  setChatDetail(chat);
  setOpenMsg(IsOpen);
  
}

const handleOpenMsg=(isOpen)=>
{
  setOpenMsg(isOpen);
  dispatch(userActions.getMessageUserList({UserID: currentUser.Id})).then((response) => {
    if (response?.type === 'users/getMessageUserList/fulfilled') {
      let userDetail={...currentUser};
      userDetail.NotificationCount=response?.payload?.Item2;
        dispatch(authActions.updateLocalStorage(userDetail));
    }
});
}

const handleRefreshChatList=()=>
  {
    dispatch(userActions.getMessageUserList({UserID: currentUser.Id})).then((response) => {
      if (response?.type === 'users/getMessageUserList/fulfilled') {
        let userDetail={...currentUser};
        userDetail.NotificationCount=response?.payload?.Item2;
          dispatch(authActions.updateLocalStorage(userDetail));
      }
  });
  }
  


  return (
    <div
      className={`tab-pane fade active show`}
      id='chat'
      role='tabpanel'
    >
      <div
        className={`card mb-sm-3 mb-md-0 contacts_card dz-chat-user-box ${
          openMsg ? 'd-none' : ''
        }`}
      >
        <div className='card-header chat-list-header text-center' style={{"background":"#e8f0fd" }}>
          <a style={{"background":"#e8f0fd" }}>
            {/* <svg
              xmlns='http://www.w3.org/2000/svg'
              xmlnsXlink='http://www.w3.org/1999/xlink'
              width='18px'
              height='18px'
              viewBox='0 0 24 24'
              version='1.1'
            > */}
              {/* <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
                <rect
                  fill='#000000'
                  x='4'
                  y='11'
                  width='16'
                  height='2'
                  rx='1'
                />
                <rect
                  fill='#000000'
                  opacity='0.3'
                  transform='translate(12.000000, 12.000000) rotate(-270.000000) translate(-12.000000, -12.000000) '
                  x='4'
                  y='11'
                  width='16'
                  height='2'
                  rx='1'
                />
              </g> */}
            {/* </svg> */}
          </a>
          <div >
            <h6 style={{"color":"#216FED" }} className='mb-1'>Chat List</h6>
            <p style={{"color":"#216FED" }} className='mb-0'></p>
          </div>
          <a onClick={() => handleRefreshChatList()}>
               <i className="fa fa-sync"></i>
               </a>
        </div>
        <PerfectScrollbar
          className={`card-body contacts_body p-0 dz-scroll  ${
            toggleChatBox ? 'ps ps--active-y' : ''
          }`}
          id='DZ_W_Contacts_Body'
        >
       <ul className='contacts'>
  {
    messageUserList && messageUserList?.length > 0 ? (
      messageUserList.map((val, index) => {
        let baseColor = '#3498DB'; // Default base color

        // Example logic to set background and text colors based on the initial letter
        switch(val.UserType) {
          case 'SuperAdmin':
            baseColor = '#00AEEF'; // Blue
            break;
          case 'Admin':
            baseColor = '#E02C2C'; // Red
            break;
          case 'Order Analyst':
            baseColor = '#80C241'; // Green
            break;
          case 'Dispatcher':
            baseColor = '#737b8b'; // Yellow
            break;
          case 'Warehouse Manager':
            baseColor = '#EA4B8D'; // Pink
            break;
          default:
            baseColor = '#004b87'; // Dark blue for others
        }

       // Lighten the base color for the background and darken for the text
       const imgContBgColor = adjustColorBrightness(baseColor, 80);  // Lighten color for background
       const imgContTextColor = adjustColorBrightness(baseColor, -80); // Darken the same color for text

        return (
        <li
          key={index} // Add a unique key for each list item to improve performance
          className='active dz-chat-user'
         // onClick={() => setOpenMsg(true)}
         onClick={() => handleMsgBox(val.UserID,val.FirstName,val.LastName,val.UserType,true)}
        >
          <div className='d-flex bd-highlight'>
            <div className='img_cont' style={{
                  backgroundColor: imgContBgColor, // Dynamic bg for img_cont
                  color: imgContTextColor,         // Dynamic text color for img_cont
                }}>
              <div className="rounded-circle user_char">
                {/* Display the first letters of FirstName and LastName */}
                {val?.FirstName?.charAt(0).toUpperCase()}{val?.LastName?.charAt(0).toUpperCase()}
              </div>
            </div>
            <div className='user_info'>
              <span>{val.FirstName + " " + (val.LastName ?? "")}</span>
              <p>{val.UserType}</p>
            </div>
            {val?.UserNotificationCount >0 &&
                <div className="message_count">
              {val.UserNotificationCount}
            </div>
            }
           
          </div>
        </li>
       );
      })
    ) : (
      <li>No contacts available</li> // Optional fallback message
    )
  }
</ul>


        </PerfectScrollbar>
      </div>
      <MsgBox
        chatDetail={chatDetail}
        openMsg={openMsg}
        PerfectScrollbar={PerfectScrollbar}
        offMsg={() => handleOpenMsg(false)}
      />
    </div>
  )
}

export default Chat
